export var BaseUrl:string = 'https://admin.qa.userinsights.kimclark.com/api/v2.0/';
export var ApiGatewayUrl:string = "https://api.qa.userinsights.kimclark.com/oauth2/authorization/okta"

